<template>
  <v-container class="my-5">
    <v-layout row wrap class="justify-center">
      <v-flex xs12>
        <v-card-title class="mb-4">
          <v-btn icon @click="$router.go(-1)" class="mr-3">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <span class="headline font-weight-bold">Academia de Golf</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <!-- Tarjetas de Estadísticas -->
        <v-row class="mb-6">
          <v-col cols="12" sm="6" md="3">
            <v-card class="text-center pa-4 elevation-1">
              <v-icon size="40" color="primary" class="mb-2">mdi-account-tie</v-icon>
              <div class="display-1 font-weight-bold primary--text">{{ totalTeachers }}</div>
              <div class="caption grey--text">Profesores Activos</div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-card class="text-center pa-4 elevation-1">
              <v-icon size="40" color="success" class="mb-2">mdi-calendar-clock</v-icon>
              <div class="display-1 font-weight-bold success--text">{{ totalClinics }}</div>
              <div class="caption grey--text">Clínicas Programadas</div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-card class="text-center pa-4 elevation-1">
              <v-icon size="40" color="info" class="mb-2">mdi-account-multiple</v-icon>
              <div class="display-1 font-weight-bold info--text">{{ totalStudents }}</div>
              <div class="caption grey--text">Alumnos Registrados</div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-card class="text-center pa-4 elevation-1">
              <v-icon size="40" color="orange" class="mb-2">mdi-calendar-check</v-icon>
              <div class="display-1 font-weight-bold orange--text">{{ upcomingClinics }}</div>
              <div class="caption grey--text">Clínicas Esta Semana</div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Próximas Clínicas -->
        <v-row class="mb-4">
          <v-col cols="12">
            <v-card>
              <v-card-title class="d-flex align-center">
                <v-icon class="mr-2">mdi-calendar-clock</v-icon>
                Próximas Clínicas
                <v-spacer></v-spacer>
                <v-btn small color="primary" to="/academy/clinics">Ver todas</v-btn>
              </v-card-title>
              <v-data-table
                :headers="upcomingHeaders"
                :items="upcomingClinicsList"
                :loading="false"
                class="elevation-0"
                hide-default-footer
                :no-data-text="'Sin clínicas programadas'">

                <template v-slot:item.date="{ item }">
                  <div class="font-weight-bold">{{ formatDate(item.date) }}</div>
                  <div class="caption grey--text">{{ item.time }}</div>
                </template>

                <template v-slot:item.teacher="{ item }">
                  <div class="font-weight-bold">{{ item.teacher }}</div>
                </template>

                <template v-slot:item.type="{ item }">
                  <v-chip small :color="getClinicTypeColor(item.type)">
                    {{ getClinicTypeLabel(item.type) }}
                  </v-chip>
                </template>

                <template v-slot:item.capacity="{ item }">
                  <div class="text-center">
                    <v-chip small>{{ item.enrolled }}/{{ item.capacity }}</v-chip>
                  </div>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>

        <!-- Acceso Rápido -->
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-card link to="/academy/teachers" class="elevation-1 hover-card">
              <v-card-text class="d-flex flex-column align-center justify-center pa-6" style="min-height: 150px;">
                <v-icon size="50" color="primary" class="mb-3">mdi-account-tie</v-icon>
                <h3 class="headline">Profesores</h3>
                <p class="caption grey--text text-center mt-2">Gestiona profesores e instructores</p>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-card link to="/academy/clinics" class="elevation-1 hover-card">
              <v-card-text class="d-flex flex-column align-center justify-center pa-6" style="min-height: 150px;">
                <v-icon size="50" color="success" class="mb-3">mdi-calendar-clock</v-icon>
                <h3 class="headline">Clínicas</h3>
                <p class="caption grey--text text-center mt-2">Programa horarios y clínicas</p>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-card link to="/academy/students" class="elevation-1 hover-card">
              <v-card-text class="d-flex flex-column align-center justify-center pa-6" style="min-height: 150px;">
                <v-icon size="50" color="info" class="mb-3">mdi-account-multiple</v-icon>
                <h3 class="headline">Alumnos</h3>
                <p class="caption grey--text text-center mt-2">Asigna alumnos a clínicas</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'AcademyDashboard',
  data () {
    return {
      upcomingHeaders: [
        { text: 'Fecha/Hora', value: 'date', width: '25%' },
        { text: 'Profesor', value: 'teacher', width: '25%' },
        { text: 'Tipo', value: 'type', width: '20%' },
        { text: 'Inscritos', value: 'capacity', width: '15%' }
      ],
      // MOCK DATA
      clinics: [
        {
          id: 1,
          teacher: 'Carlos López García',
          type: 'swing',
          date: '2025-08-08',
          time: '09:00',
          capacity: 6,
          enrolled: 4,
          description: 'Técnica de Swing Avanzado',
          level: 'intermedio'
        },
        {
          id: 2,
          teacher: 'María Rodríguez',
          type: 'putting',
          date: '2025-08-09',
          time: '10:00',
          capacity: 8,
          enrolled: 7,
          description: 'Masterclass de Putting',
          level: 'avanzado'
        },
        {
          id: 3,
          teacher: 'Fernando Ruiz',
          type: 'pitch',
          date: '2025-08-10',
          time: '14:00',
          capacity: 6,
          enrolled: 2,
          description: 'Técnica de Pitch y Chip',
          level: 'basico'
        },
        {
          id: 4,
          teacher: 'Carlos López García',
          type: 'full_swing',
          date: '2025-08-12',
          time: '09:00',
          capacity: 10,
          enrolled: 8,
          description: 'Swing Completo - Fundamentos',
          level: 'basico'
        },
        {
          id: 5,
          teacher: 'María Rodríguez',
          type: 'short_game',
          date: '2025-08-15',
          time: '10:00',
          capacity: 8,
          enrolled: 3,
          description: 'Juego Corto Profesional',
          level: 'intermedio'
        }
      ],
      teachers: [
        { id: 1, name: 'Carlos López García', availability: 'Lunes, Miércoles, Viernes' },
        { id: 2, name: 'María Rodríguez', availability: 'Martes, Jueves, Sábado' },
        { id: 3, name: 'Fernando Ruiz', availability: 'Lunes, Miércoles, Sábado' }
      ],
      students: [
        { id: 1, name: 'Juan García', level: 'intermedio', clinics_enrolled: 2 },
        { id: 2, name: 'Ana Martínez', level: 'avanzado', clinics_enrolled: 3 },
        { id: 3, name: 'Roberto Díaz', level: 'basico', clinics_enrolled: 1 }
      ]
    }
  },
  computed: {
    totalTeachers () {
      return this.teachers.length
    },
    totalClinics () {
      return this.clinics.length
    },
    totalStudents () {
      return this.students.length
    },
    upcomingClinics () {
      const today = new Date()
      const nextWeek = new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000)
      return this.clinics.filter(c => {
        const clinicDate = new Date(c.date)
        return clinicDate >= today && clinicDate <= nextWeek
      }).length
    },
    upcomingClinicsList () {
      const today = new Date()
      return this.clinics
        .filter(c => new Date(c.date) >= today)
        .sort((a, b) => new Date(a.date) - new Date(b.date))
        .slice(0, 5)
    }
  },
  methods: {
    formatDate (dateStr) {
      const date = new Date(dateStr)
      return date.toLocaleDateString('es-MX', {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      })
    },
    getClinicTypeColor (type) {
      const colors = {
        swing: 'blue',
        putting: 'green',
        pitch: 'orange',
        full_swing: 'purple',
        short_game: 'red'
      }
      return colors[type] || 'grey'
    },
    getClinicTypeLabel (type) {
      const labels = {
        swing: 'Swing',
        putting: 'Putting',
        pitch: 'Pitch',
        full_swing: 'Swing Completo',
        short_game: 'Juego Corto'
      }
      return labels[type] || 'Otro'
    }
  }
}
</script>

<style scoped>
.hover-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
}

.hover-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15) !important;
}
</style>
